import $ from 'jquery';
import Swiper from 'swiper/bundle';

$(document).ready(function () {
	// Common
	const gnav = $('#header-gnav');
	const bar = $('#header-navbar');
	if (gnav.length && bar.length) {
		$('.menu-item-has-children', gnav).on('click', function (ev) {
			ev.stopPropagation();
			ev.preventDefault();
			let sub = $('>.sub-menu', this);
			if (sub.length) {
				$(this).toggleClass('menu-item-open');
				sub.slideToggle(200);
			}
		});

		$('.menu-item>a').on('click', function (ev) {
			ev.stopPropagation();
		});

		bar.on('click', function () {
			$('body').toggleClass('gnav-active');
			$(this).toggleClass('is-active');
			gnav.toggleClass('is-active');
			gnav.slideToggle(200);
		});
	}

	// Top
	const pageTop = $('#page-top');
	if (pageTop.length) {
		const topMv = $('#top-main-swiper');
		if (topMv.length) {
			new Swiper('#top-main-swiper', {
				loop: true,
				lazy: true,
				speed: 1000,
				centeredSlides: true,
				effect: 'fade',
				autoplay: {
					delay: 4000,
					disableOnInteraction: false
				},
				pagination: {
					el: '.swiper-pagination',
					dynamicBullets: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			});
		}
	}

	//partners-slider
	const partnerSlider = $('#partners-slider');
	if (partnerSlider.length) {
		new Swiper('#partners-slider', {
			loop: true,
			lazy: true,
			speed: 2500,
			slidesPerView: 4,
			spaceBetween: 15,
			freeMode: true,
			allowTouchMove: false,
			simulateTouch: false,
			autoplay: {
				delay: -10,
				disableOnInteraction: false
			},
			breakpoints: {
				768: {
					slidesPerView: 7,
					spaceBetween: 30,
				}
			}
		});
	}
});
